import DashboardNav from "../components/DashboardNav/DashboardNav";
import QrCodeEdit from "../components/QrCodeEdit/QrCodeEdit";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";

const EditQrCodePage = () => {
  return (
    <div className="editQrCodePage">
      <div className="dahsboard__menu">
        <DashboardNav />
      </div>
      <div className="editQrCodePage__container">
        <QrCodeEdit />
      </div>
    </div>
  );
};

export default EditQrCodePage;
